import { useNavigate } from 'react-router';

import { ActionPanel, Box } from '@thirdspacelearning/library';

import notFoundSvg from '@assets/not-found.svg';

const sx = {
    panelContainer: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
    },
    actionPanelCard: {
        maxWidth: '435px',
    },
};

const RedirectActionPanel = () => {
    const navigate = useNavigate();

    const onRedirect = () => {
        navigate('/');
    };

    return (
        <Box sx={sx.panelContainer}>
            <ActionPanel
                type="error"
                decoration={<img src={notFoundSvg} alt="404 Page not found" />}
                title="Something doesn't add up"
                textContent="We couldn't find the page you were looking for"
                buttonLabel="Return home"
                buttonAction={onRedirect}
                sx={sx.actionPanelCard}
            />
        </Box>
    );
};

export default RedirectActionPanel;
